
import { Step } from "@/lib/types";

export const signupStep: Step = {
  id: "signup",
  type: "multiStep",
  title: "Sign-up",
  description: "Let's collect some information to get you started.",
  buttonText: "Continue",
  subSteps: [
    {
      id: "email",
      title: "What's your email?",
      description: "Please enter your email address below.\n\n**Important: Please keep this page open until you finish the full onboarding, or your progress won't be saved.**",
      todos: [],
      buttonText: "Continue",
      inputs: [
        {
          name: "email",
          type: "email",
          label: "Email Address",
          placeholder: "Enter your email address"
        }
      ]
    },
    {
      id: "name",
      title: "What's your name?",
      description: "Please enter your full name below.",
      todos: [],
      buttonText: "Continue",
      inputs: [
        {
          name: "name",
          type: "text",
          label: "Full Name",
          placeholder: "Enter your full name"
        }
      ]
    },
    {
      id: "whatsapp",
      title: "What's your WhatsApp?",
      description: "Please enter your WhatsApp number below.",
      todos: [],
      buttonText: "Verify Number",
      inputs: [
        {
          name: "whatsapp",
          type: "phone",
          label: "WhatsApp Number",
          placeholder: "+1 (555) 123-4567"
        }
      ]
    }
  ]
};
